import {Button, Grid2, MenuItem} from '@mui/material';
import {RhfCheckboxGroup, RhfTextField} from 'mui-rhf-integration';
import {RhfDatePicker} from 'mui-rhf-integration/date-picker';
import type {ReactNode} from 'react';
import {useFormContext} from 'react-hook-form';
import EmployeeForm from '@/components/OnBoarding/EmployeeForm.tsx';

const OnBoardingForm = (): ReactNode => {
    const {watch, control} = useFormContext();
    const associateTypeWatch = watch('associateType');

    return (
        <Grid2 container spacing={2}>
            <Grid2 size={12} sx={{p: 1}}>
                <RhfTextField
                    select
                    control={control}
                    name='associateType'
                    label='Associate Type'
                    sx={{
                        width: '100%',
                        backgroundColor: '#fff',
                    }}
                >
                    <MenuItem value='10119'>Employee</MenuItem>
                    <MenuItem value='10120'>Contractor</MenuItem>
                </RhfTextField>
            </Grid2>
            <Grid2 size={6} sx={{p: 1}}>
                <RhfTextField label='First Name' control={control} name='firstName' />
            </Grid2>
            <Grid2 size={6} sx={{p: 1}}>
                <RhfTextField label='Last Name' control={control} name='lastName' />
            </Grid2>
            <Grid2 size={12} sx={{p: 1}}>
                <RhfDatePicker
                    control={control}
                    name='startDate'
                    label='Start Date'
                    sx={{
                        backgroundColor: '#fff',
                    }}
                />
            </Grid2>
            <Grid2 size={12} sx={{p: 1}}>
                <RhfCheckboxGroup
                    control={control}
                    name='groups'
                    label='Groups'
                    options={[
                        {value: '10155', label: 'DL.CNA'},
                        {value: '10156', label: 'DL.Claris'},
                        {value: '10157', label: 'SalesForce'},
                        {value: '10162', label: 'VPN Users - Assumed for Employees'},
                        {value: '10159', label: 'proposals - Normally for PM or Tech Lead'},
                        {
                            value: '10161',
                            label: 'ww-administrators - Normally for PM or Tech Lead',
                        },
                        {value: '10158', label: 'pmforum - Normally for PM'},
                        {value: '10160', label: 'crowd-add-user - Normally for PM'},
                    ]}
                />
            </Grid2>
            {associateTypeWatch === '10119' && <EmployeeForm />}
            <Grid2 size={12} sx={{p: 1}}>
                <Button type='submit'>Submit</Button>
            </Grid2>
        </Grid2>
    );
};

export default OnBoardingForm;
